module.exports = __webpack_public_path__ + "img/icon_noGame.4d9b4919.svg";